'use strict';

export class TranslateProvider {
  constructor() {
    'ngInject';

    this.options = {}
  }

  config(values) {
    angular.extend(this.options, values);
  }

  $get() {
    'ngInject';
    const { options } = this;

    return {
      options
    };
  }
}
